import React from 'react';

/**
 * ShipmentPalletPreview - Modal to preview pallet details from within shipment view
 * Shows pallet info, photo, and items list
 */
const ShipmentPalletPreview = ({
  isOpen,
  onClose,
  pallet,
  loading
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal pallet-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {pallet ? `Pallet ${pallet.pallet_number}` : 'Loading...'}
          </h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="loading-message">Loading pallet details...</div>
          ) : pallet ? (
            <>
              <div className="preview-info-grid">
                <div className="preview-info-item">
                  <span className="label">Lot Number:</span>
                  <span className="value">{pallet.lot_number}</span>
                </div>
                <div className="preview-info-item">
                  <span className="label">Customer:</span>
                  <span className="value">{pallet.customer_name || 'N/A'}</span>
                </div>
                <div className="preview-info-item">
                  <span className="label">Status:</span>
                  <span className={`status-badge ${pallet.status}`}>{pallet.status}</span>
                </div>
                <div className="preview-info-item">
                  <span className="label">Total Weight:</span>
                  <span className="value">{parseFloat(pallet.total_weight || 0).toFixed(2)} kg</span>
                </div>
                {pallet.label_text && (
                  <div className="preview-info-item">
                    <span className="label">Label:</span>
                    <span className={`pallet-label-badge ${pallet.label_color || 'gray'}`}>
                      {pallet.label_text}
                    </span>
                  </div>
                )}
              </div>

              {pallet.image_path && (
                <div className="preview-image-section">
                  <h4>Photo</h4>
                  <img
                    src={`${process.env.REACT_APP_API_URL?.replace('/api', '') || ''}/uploads/${pallet.image_path}`}
                    alt="Pallet"
                    className="preview-pallet-image"
                  />
                </div>
              )}

              <div className="preview-items-section">
                <h4>Items ({pallet.items?.length || 0})</h4>
                {pallet.items && pallet.items.length > 0 ? (
                  <table className="preview-items-table">
                    <thead>
                      <tr>
                        <th>Part #</th>
                        <th>Name</th>
                        <th>Qty</th>
                        <th>Lot #</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pallet.items.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.part_number}</td>
                          <td>{item.name}</td>
                          <td>{item.quantity}</td>
                          <td>{item.lot_number || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="no-items">No items on this pallet</p>
                )}
              </div>
            </>
          ) : (
            <div className="error-message">Failed to load pallet details</div>
          )}
        </div>
        <div className="modal-footer">
          <button className="modal-btn close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ShipmentPalletPreview;
